import { adjust, curry, head, isEmpty, join, map, pipe, replace, split, toLower, type } from 'ramda'
import { capitalize } from '@btime/helpers'
import moment from 'moment'

// TODO: Move to @btime/helpers

export const splitWords = split(new RegExp(/[/\-_ ]/gi))

export const toKebabCase = str => {
  return str
    .split('')
    .map((letter, index) => {
      if (letter === '_') return '-'
      if (letter?.toUpperCase() === letter) return `${index !== 0 ? '-' : ''}${letter?.toLowerCase()}`
      return letter
    })
    .join('')
}

export const toSnakeCase = pipe(toKebabCase, replace(/-/g, '_'))

export const toCamelCase = pipe(splitWords, map(capitalize), adjust(0, toLower), join(''))

export const truncateString = curry((str, size) => {
  if (!!str && str.length > size) return str.substring(0, size) + '...'
  return str
})
export const truncate = truncateString

const PROTOCOLS = 'http|https|dhcp|xmpp|ftp|sftp|ftps|ssh|pop|imap|smtp'

const URL_PATTERN = new RegExp(
  `^((${PROTOCOLS})?:\\/\\/)?` + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(.[;&@\\-\\/!,:?a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
  'i'
) // fragment locator

export const isUrlValid = str => {
  return !!URL_PATTERN.test(str)
}

export const compactString = (value, options = {}) => {
  const key = options.key || 'name'
  const limit = options.truncateLimit || 1
  const truncate = options.truncate || 10
  const t = options.t
  const field = options.tField

  if (isEmpty(value)) return false

  if (type(value) === 'Array' && type(head(value)) === 'Object') {
    if (value.length > limit || value.some(item => !(item[key] || item?.label))) {
      if (t && field) {
        return t('filter.' + field, { count: value.length })
      } else {
        return `${value.length} itens`
      }
    }
    return truncateString(value.map(item => item[key] || item?.label).join(', '), truncate)
  }

  if (type(value) === 'Array' && (type(head(value)) === 'Date' || moment(head(value)).isValid())) {
    const [from, to] = value
    const format = 'DD/MM'
    const label = `${moment(from).format(format)}-${moment(to).format(format)}`
    return label
  }

  if (type(value) === 'Object') {
    return value[key] || value?.label
  }

  return false
}
